import AboutUsNewDesign from "./AboutUsNewDesign";

export default AboutUsNewDesign;
